// extracted by mini-css-extract-plugin
module.exports = {"selectedColor":"#a9c480"};